import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { htmlEscape, dataTruncate } from "lib/helpers"

// notifier--subscription on `app/views/notifier/subscription/index.haml`.
export default class extends Controller {
  static targets = ["table", "dialog", "checkAll"]

  static values = {
    removeSubscriptionsPath: String,
    subscriptionsRootPath: String,
    usersServiceRoot: String,
    reader: { type: Boolean, default: false },
  }

  connect() {
    if (!this.hasTableTarget) return

    this._openDialog = (path, id) => this.openDialog(path, id)
    this._removeOne = (id) => this.removeOne(id)
    this._removeMany = () => this.removeMany()
    window.subscriptionDialog = this._openDialog
    window.removeSubscription = this._removeOne
    window.removeSubscriptions = this._removeMany

    this.#initDataTable()
    this.#bindCheckboxChanges()
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
    $(document).off(".notifierSubscription")
    if (this.hasCheckAllTarget) $(this.checkAllTarget).off(".notifierSubscription")

    if (window.subscriptionDialog === this._openDialog) delete window.subscriptionDialog
    if (window.removeSubscription === this._removeOne) delete window.removeSubscription
    if (window.removeSubscriptions === this._removeMany) delete window.removeSubscriptions
  }

  openDialog(path, id) {
    $(this.dialogTarget).load(`${path}${id}`, () => {
      $("#subscription-modal").modal("show")
      $("#subscription-modal").find(".modal-title").append(` ${id}`)
    })
  }

  openDeviceDialog(event) {
    const link = event.target.closest("a[data-device-id]")
    if (!link || !this.element.contains(link)) return

    event.preventDefault()
    this.openDialog(`${this.subscriptionsRootPathValue}/`, link.dataset.deviceId)
  }

  removeOne(id) {
    if (!confirm("Are you sure?")) return false

    $(".dataTables_processing").css("display", "block")

    $.get(this.removeSubscriptionsPathValue, { item_ids: $.makeArray(id) }, () => {
      $("#subscription-modal").modal("hide")
      if (this.dataTable) this.dataTable.ajax.reload()
    })
  }

  removeMany(event) {
    if (event) event.preventDefault()

    const groupName = this.checkAllTarget.value
    const checkboxes = $(`input[name^='${groupName}']:checked`)
    const available = $(`input[name^='${groupName}']`)

    if (!available.length) return
    if (!checkboxes.length) {
      alert("Please select at least one item")
      return
    }
    if (!confirm("Are you sure? All selected items will be removed")) return

    $(".dataTables_processing").css("display", "block")

    const ids = $.makeArray(checkboxes.map(function () { return $(this).val() }))

    $.get(this.removeSubscriptionsPathValue, { item_ids: ids }, () => {
      if (this.dataTable) this.dataTable.ajax.reload()
    })
    this.checkAllTarget.checked = false
  }

  #initDataTable() {
    const usersRoot = this.usersServiceRootValue
    const controller = this

    this.dataTable = createTurboDataTable(this.tableTarget, {
      dom: 'lfrt<"toolbar">ip',
      pagingType: "full_numbers",
      processing: true,
      serverSide: true,
      stateSave: false,
      scrollX: true,
      ajax: this.subscriptionsRootPathValue || "subscriptions",
      stateLoadParams(settings, data) {
        data.search.search = ""
      },
      language: {
        searchPlaceholder: "At least 3 symbols",
      },
      footerCallback() {
        $("#check-all").attr("checked", false)
      },
      initComplete() {
        $("#loading").hide()
        $("#messages-device").show()
      },
      columnDefs: [
        {
          targets: 0,
          createdCell(cell, cellData) {
            $(cell).html(
              `<input type="checkbox" class="table-checkbox-subscription" id="check--subscription${cellData}" name="item_ids[]" value="${cellData}"/> <label for="check--subscription${cellData}"><label/>`,
            )
          },
        },
        {
          targets: 2,
          createdCell(cell, cellData, rowData) {
            if (rowData[4] === "email") {
              $(cell).html(rowData[7])
            } else {
              const truncated = dataTruncate(htmlEscape(rowData[2]), 40)
              $(cell).html(
                `<a href="#" data-turbo="false" id="device${rowData[1]}" data-device-id="${rowData[1]}"><span>${truncated}</span></a>`,
              )
            }
          },
        },
        {
          targets: 3,
          createdCell(cell, cellData, rowData) {
            $(cell).html(
              `<a href="${usersRoot}/edit/${rowData[6]}"><span>${dataTruncate(htmlEscape(rowData[3]), 20)}</span></a>`,
            )
          },
        },
        {
          targets: 4,
          createdCell(cell, cellData) {
            controller.#renderChannelCell(cell, cellData)
          },
        },
        {
          targets: 6,
          createdCell(cell, cellData, rowData) {
            $(cell).html(rowData[8])
          },
        },
        {
          targets: [0, 2, 3],
          sortable: false,
        },
      ],
    })

    if (!this.readerValue) this.#installToolbar()
  }

  #installToolbar() {
    $("div.toolbar")
      .not(".rich")
      .html(
        '<br><a href="#" class="remove" data-action="click->notifier--subscription#removeMany">Remove selected</a>',
      )
  }

  #renderChannelCell(cell, cellData) {
    let title
    switch (cellData) {
      case "apns":
        title = "APNS"
        return $(cell).html(
          `<img src="${window.apple_logo_url}" alt="${title}" title="${title}"/>&nbsp;${title}`,
        )
      case "apns_voip":
        title = "APNS VOIP"
        return $(cell).html(
          `<img src="${window.apple_logo_url}" alt="${title}" title="${title}"/>&nbsp;${title}`,
        )
      case "gcm":
        title = "FCM"
        return $(cell).html(
          `<img src="${window.android_logo_url}" alt="${title}" title="${title}"/>&nbsp;${title}`,
        )
      case "email":
        title = "E-Mail"
        return $(cell).html(
          `<img src="${window.tick_logo_url}" alt="${title}" title="${title}"/>&nbsp;${title}`,
        )
    }
  }

  #bindCheckboxChanges() {
    $(document).on("change.notifierSubscription", ".table-checkbox-subscription", function () {
      $(this).closest("tr").toggleClass("selected-row", $(this).prop("checked"))

      const selectedCount = $("input.table-checkbox-subscription:checked").length
      const totalCount = $("input.table-checkbox-subscription").length
      $("#check-all").prop("checked", selectedCount > 0 && selectedCount === totalCount)
    })

    $(this.checkAllTarget).on("change.notifierSubscription", function () {
      const isChecked = $(this).prop("checked")
      $(".table-checkbox-subscription")
        .prop("checked", isChecked)
        .closest("tr")
        .toggleClass("selected-row", isChecked)
    })
  }
}
